<div class="container">
  <div class="container-table">
    <header class="top-header">
      <h3>Application Logs</h3>
      <p>Production activity and failures, latest first</p>
    </header>

    <div class="tab-head log-filter-bar">
      <div class="log-actions">
        <div class="log-filters">
          <label class="filter-input compact-input">
            <span>Date</span>
            <select [(ngModel)]="dateRange" (change)="onDateRangeChange()">
              <option *ngFor="let option of dateRangeOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </label>

          <label *ngIf="dateRange === 'custom'" class="filter-input compact-input">
            <span>Custom Date</span>
            <p-datepicker
              [(ngModel)]="customDate"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              inputId="logs-custom-date"
              [showOnFocus]="true"
              [showButtonBar]="true"
              [readonlyInput]="true"
              (onSelect)="onCustomDateChange()"
              (onClose)="onCustomDateChange()"
            ></p-datepicker>
          </label>

          <label class="filter-input compact-input">
            <span>Level</span>
            <select [(ngModel)]="levelFilter" (change)="onLevelChange()">
              <option *ngFor="let option of levelOptions" [value]="option">{{ option === 'ALL' ? 'All Levels' : option }}</option>
            </select>
          </label>

          <label class="filter-input compact-input">
            <span>Status</span>
            <select [(ngModel)]="statusFilter" (change)="onStatusChange()">
              <option *ngFor="let option of statusOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </label>

          <label class="filter-input compact-input">
            <span>Category</span>
            <select [(ngModel)]="categoryFilter" (change)="onCategoryChange()">
              <option *ngFor="let option of categoryOptions" [value]="option">{{ option === 'ALL' ? 'All Types' : option }}</option>
            </select>
          </label>

          <label class="filter-input search-input">
            <span>Search</span>
            <div class="search-control">
              <input
                type="text"
                [(ngModel)]="searchTerm"
                (ngModelChange)="onSearchChange($event)"
                placeholder="Request ID, endpoint, message, user ID"
              />
              <button type="button" class="clear-search" (click)="clearSearch()" [disabled]="!searchTerm">Clear</button>
            </div>
          </label>
        </div>

        <button class="export-button" (click)="fetchLogs()">Refresh</button>
      </div>

      <div class="log-summary" *ngIf="!loading">
        <div class="summary-pill">
          <span class="summary-label">Errors</span>
          <strong>{{ summaryByCategory['ERROR'] || summaryByStatus['500'] || 0 }}</strong>
        </div>
        <div class="summary-pill">
          <span class="summary-label">Security</span>
          <strong>{{ summaryByCategory['SECURITY'] || 0 }}</strong>
        </div>
        <div class="summary-pill">
          <span class="summary-label">Slow / Warning</span>
          <strong>{{ summaryByLevel['WARNING'] || 0 }}</strong>
        </div>
      </div>
    </div>

    <div class="responsive-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>DATE &amp; TIME</th>
            <th>LEVEL / CATEGORY</th>
            <th>STATUS</th>
            <th>REQUEST</th>
            <th>MESSAGE</th>
            <th>ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="6">Loading logs...</td>
          </tr>
          <tr *ngFor="let entry of logs">
            <td>{{ entry.timestamp || '-' }}</td>
            <td>
              <div class="type-cell">
                <span class="category-badge" [ngClass]="categoryClass(entry.category)">{{ entry.category || '-' }}</span>
                <span class="level-badge" [ngClass]="entry.level.toLowerCase()">{{ entry.level }}</span>
              </div>
            </td>
            <td>
              <span class="status-badge" [ngClass]="statusClass(entry.status_code)">{{ entry.status_code || '-' }}</span>
            </td>
            <td class="request-cell">
              <div>{{ entry.method || '-' }} {{ entry.endpoint || '-' }}</div>
              <small>{{ entry.request_id || '-' }}</small>
            </td>
            <td class="log-message">{{ entry.message }}</td>
            <td>
              <button class="detail-button" (click)="openDetails(entry)">View Details</button>
            </td>
          </tr>
          <tr *ngIf="!loading && logs.length === 0">
            <td colspan="6">No logs found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="footer">
      <div class="total-records">Total Records: {{ totalRecords }}</div>
      <div class="pagination-controls">
        <label for="recordsPerPage">Records per page </label>
        <select id="recordsPerPage" [(ngModel)]="pageSize" (change)="selectPageSize()">
          <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
        </select>
        <span>{{ currentPage }} / {{ totalPages }}</span>
        <button (click)="previous()" [disabled]="currentPage <= 1" class="change-page" title="Previous page">
          <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
        </button>
        <button (click)="next()" [disabled]="currentPage >= totalPages" class="change-page" title="Next page">
          <fa-icon [icon]="['fas', 'angle-right']" class="fa-light"></fa-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showDetails" class="confirmation-modal">
  <div class="modal-content log-detail-modal">
    <div class="modal-header">
      <h3>Log Details</h3>
    </div>
    <div class="modal-body log-detail-body">
      <div class="detail-section">
        <h4>Basic Information</h4>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">Date &amp; Time</span>
            <span class="detail-value">{{ formatValue(selectedLog?.timestamp) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Level</span>
            <span class="detail-value">{{ formatValue(selectedLog?.level) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Category</span>
            <span class="detail-value">{{ formatValue(selectedLog?.category) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Status Code</span>
            <span class="detail-value">{{ formatValue(selectedLog?.status_code) }}</span>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <h4>Request Information</h4>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">Method</span>
            <span class="detail-value">{{ formatValue(selectedLog?.method) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Endpoint</span>
            <span class="detail-value">{{ formatValue(selectedLog?.endpoint) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Request ID</span>
            <span class="detail-value">{{ formatValue(selectedLog?.request_id) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Duration</span>
            <span class="detail-value">{{ selectedLog?.duration_ms ? (selectedLog?.duration_ms + ' ms') : '-' }}</span>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <h4>User Information</h4>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">User</span>
            <span class="detail-value">{{ formatValue(selectedLog?.user_id) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Organization</span>
            <span class="detail-value">{{ formatValue(selectedLog?.organization_id) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">IP Address</span>
            <span class="detail-value">{{ formatValue(selectedLog?.ip_address) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">User Agent</span>
            <span class="detail-value">{{ formatValue(selectedLog?.user_agent) }}</span>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <h4>Message</h4>
        <pre class="detail-pre">{{ formatValue(selectedLog?.message) }}</pre>
      </div>

      <div class="detail-section" *ngIf="selectedLog?.stack_trace">
        <h4>Stack Trace</h4>
        <pre class="detail-pre">{{ formatValue(selectedLog?.stack_trace) }}</pre>
      </div>

      <div class="detail-section" *ngIf="selectedLog?.context_data || selectedLog?.payload_summary">
        <h4>Context Data</h4>
        <pre class="detail-pre">{{ formatValue(selectedLog?.context_data || selectedLog?.payload_summary) }}</pre>
      </div>
    </div>
    <div class="modal-footer">
      <button (click)="closeDetails()" class="cancel-btn cancel-btn-green">Close</button>
    </div>
  </div>
</div>
